import { Registry } from 'src/types/registry'
import NiceModal from '@ebay/nice-modal-react'
import { useEffect } from 'react'
import GiftGiverReminderModal from '../../components/GiftGiverReminderModal'

type UseGiftGiverRemindersProps = {
  registry: Registry | undefined
}

export const REMINDER_DELAY = 60000

const useGiftGiverReminders = ({ registry }: UseGiftGiverRemindersProps) => {
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    if (registry?.isEligibleForGiftGiverReminders) {
      timer = setTimeout(() => {
        NiceModal.show(GiftGiverReminderModal)
      }, REMINDER_DELAY)
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [registry])
}

export default useGiftGiverReminders
